

export default {
  name: "Zoom",
  props: {
    imgUrl: String,
  },
  data() {
    return {
    };
  },
  methods: {
    handler(event) {
      let mask = this.$refs.mask;
      // let bigImg = this.$refs.big;
      // 遮罩层可移动的范围：鼠标的当前坐标到该元素的距离（左侧、顶部）减去 遮罩层宽、高的一半(遮罩层始终是一个以鼠标为中心的正方形)
      let left = event.offsetX - mask.offsetWidth / 2;
      let top = event.offsetY - mask.offsetHeight / 2;
      // 约束遮罩层可移动的范围
      if (left <= 0) left = 0;
      if (left >= mask.offsetWidth) left = mask.offsetWidth;
      if (top <= 0) top = 0;
      if (top >= mask.offsetHeight) top = mask.offsetHeight;

      // 修改元素的left|top属性值
      mask.style.left = left + "px";
      mask.style.top = top + "px";
      // bigImg.style.left = -2 * left + "px";
      // bigImg.style.top = -2 * top + "px";
      let obj = {};
      obj.left = left;
      obj.top = top;
      obj.bigShow = true;
      this.$emit("sendStyle", obj);
    },
    leave() {
      let obj = {};
      obj.left = 0;
      obj.top = 0;
      obj.bigShow = false;
      this.$emit("sendStyle", obj);
    },
  },
};
